import type { CSSProperties } from "react";
import { DolapoTextProp } from "../props/interface";
import { TextAlign, TextStyle } from "../props/enums";

const textAlignMap: Record<number, CSSProperties["textAlign"]> = {
  [TextAlign.LEFT]: "left",
  [TextAlign.CENTER]: "center",
  [TextAlign.RIGHT]: "right",
};

const fontWeightMap: Record<
  number,
  NonNullable<CSSProperties["fontWeight"]>
> = {
  [TextStyle.NORMAL]: "normal",
  [TextStyle.SEMIBOLD]: "600",
  [TextStyle.BOLD]: "700",
};

function DolapoText(props: DolapoTextProp) {
  const textStyle: CSSProperties = {
    fontSize: `${props.size}px`,
    color: props.color,
    textAlign: textAlignMap[props.textalign] ?? "left",
    fontWeight: fontWeightMap[props.fontWeight] ?? "400",
    marginBottom: props.hasMarginBottom ? `${props.marginBottom}px` : "0px",
    display: "block",
    fontFamily: "LeagueSpartan, sans-serif",
  };

  return (
    <div className="w-full">
      <p style={textStyle}>{props.content}</p>
      {props.underline && (
        <img
          src={require("../asset/image/section-indicator.png")}
          alt="section indicator"
          className="mx-auto mb-5 block"
        />
      )}
    </div>
  );
}

export default DolapoText;
